import Axios from "axios";

export const FormDynamic = () => {

  function ready(fn) {
    if (document.readyState !== "loading") {
      fn();
    } else {
      document.addEventListener("DOMContentLoaded", fn);
    }
  }

  ready(refreshCSRF);

  function refreshCSRF() {
    try {
      let forms = [...document.querySelectorAll("form")].filter(form => form.dataset.handle);
      if (forms.length === 0) {
        return;
      }

      for (let form of forms) {
        let handle = form.dataset.handle ?? null;

        Axios({
          url: "/dynamic/form?form=" + handle,
          method: "GET",
        }).then((response) => {
          if (! response.data.hash) {
            return;
          }
          form.querySelector("input[name=formHash]").value = response.data.hash;

          // Update the JS Honeypot (ONLY when JS Enhancement setting is ON)
          if  (!response.data.honeypot) {
            return
          }
          let honeypot = response.data.honeypot;
          let honeypotInput = form.querySelector(
              'input[name^="freeform_form_handle"]'
          );

          if (honeypotInput) {
            honeypotInput.setAttribute("id", honeypot.name);
            honeypotInput.setAttribute("name", honeypot.name);
            honeypotInput.value = honeypot.hash;
          }

          if (!response.data.csrf) {
            return;
          }
          // Locate and update the CSRF input
          const csrf = response.data.csrf;

          form.querySelector("input[name=" + csrf.name + "]").value = csrf.value;
        }).catch((err)=>{
          console.error(err);
        });

      }
    } catch (e) {
      console.error(e);
    }
  }
};
